export const schemaDataDoctors = {
  "doctors/homeopathic-doctors-online": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "MedicalSpecialty",
        "@id": "https://holypills.in/doctors/homeopathic-doctors-online",
        name: "Homeopathy",
        description:
          "Our experienced team of homeopathy doctors is here to provide an individualized approach and support your health journey. From managing symptoms to providing intensive consultations, you’ll be guided at every stage",
        url: "https://holypills.in/doctors/homeopathic-doctors-online",
        mainEntityOfPage:
          "https://holypills.in/doctors/homeopathic-doctors-online",
      },
      {
        "@type": "Physician",
        "@id": "https://holypills.in/doctors-details/dr-ila-kathuria",
        name: "Dr. Ila Kathuria",
        image:
          "https://holypills.in/blog/wp-content/uploads/2025/11/Dr-Ila-.webp",
        url: "https://holypills.in/doctors/homeopathic-doctors-online",
        medicalSpecialty: ["Homeopathy"],
        knowsAbout: [
          "Women's Health",
          "PCOS",
          "Endometriosis",
          "Menopause",
          "Postpartum Recovery",
          "Holistic Healing",
        ],
        sameAs: [
          "https://www.facebook.com/drila.kathuria/",
          "https://x.com/DrKathuria283",
          "https://www.linkedin.com/in/ila-kathuria-710941370/",
          "https://holypills.in/doctors-details/dr-ila-kathuria",
        ],
        mainEntityOfPage:
          "https://holypills.in/doctors/homeopathic-doctors-online",
      },
    ],
  },
  "doctors/consult-with-nutritionist-online": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "MedicalSpecialty",
        "@id": "https://holypills.in/doctors/consult-with-nutritionist-online",
        name: "Nutrition Science",
        alternateName: "Nutrition & Dietetics",
        description:
          "Holypills’ certified nutritionists and dietitians provide personalized diet plans and nutritional counseling to help you achieve your health and wellness goals naturally.",
        url: "https://holypills.in/doctors/consult-with-nutritionist-online",
        mainEntityOfPage:
          "https://holypills.in/doctors/consult-with-nutritionist-online",
      },
      {
        "@type": "Physician",
        "@id": "https://holypills.in/doctors-details/chhavi-goel",
        name: "Chhavi Goel",
        image:
          "https://holypills-prod-bucket.s3.us-east-1.amazonaws.com/Holypills/doctor/1760352462061.webp",
        url: "https://holypills.in/doctors/consult-with-nutritionist-online",
        medicalSpecialty: [
          "Nutrition Science",
          "Diet Therapy",
          "Lifestyle Management",
        ],
        knowsAbout: [
          "Clinical Nutrition",
          "PCOS Diet Management",
          "Weight Management",
          "Holistic Nutrition",
          "Postpartum Nutrition",
          "Endometriosis Diet Support",
        ],
        sameAs: [
          "https://www.youtube.com/@dietitianchhavigoel",
          "https://www.instagram.com/dietitianchhavigoel/",
          "https://www.linkedin.com/in/dr-chhavi-goel/",
          "https://holypills.in/doctors-details/chhavi-goel",
        ],
        mainEntityOfPage:
          "https://holypills.in/doctors/consult-with-nutritionist-online",
      },
    ],
  },
  "doctors/fitness-expert-online": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "MedicalSpecialty",
        "@id": "https://holypills.in/doctors/fitness-experts-online",
        name: "Fitness & Physical Wellbeing",
        alternateName: "Fitness Coaching",
        description:
          "Holypills’ certified fitness experts and wellness coaches offer customized fitness programs and lifestyle guidance to improve your physical and mental wellbeing.",
        url: "https://holypills.in/doctors/fitness-experts-online",
        mainEntityOfPage: "https://holypills.in/doctors/fitness-experts-online",
      },
      {
        "@type": "ItemList",
        "@id": "https://holypills.in/doctors/fitness-expert-online",
        name: "Fitness Coaches at Holypills",
        numberOfItems: 2,
        itemListOrder: "Ascending",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            item: {
              "@type": "Person",
              "@id": "https://holypills.in/doctors-details/supriya-sharma",
              name: "Supriya Sharma",
              jobTitle: "Certified Fitness Coach",
              image:
                "https://holypills-prod-bucket.s3.us-east-1.amazonaws.com/Holypills/doctor/1760352375751.webp",
              url: "https://holypills.in/doctors/fitness-experts-online",
              worksFor: { "@id": "https://holypills.in/#organization" },
              knowsAbout: [
                "Strength Training",
                "Body Recomposition",
                "Women’s Fitness",
                "Functional Workouts",
                "Weight Management",
              ],
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            item: {
              "@type": "Person",
              "@id": "https://holypills.in/doctors-details/vaibhavi-likhite",
              name: "Vaibhavi Likhite",
              jobTitle: "Wellness & Fitness Coach",
              image:
                "https://holypills-prod-bucket.s3.us-east-1.amazonaws.com/Holypills/doctor/1760352429334.webp",
              url: "https://holypills.in/doctors/fitness-experts-online",
              worksFor: { "@id": "https://holypills.in/#organization" },
              knowsAbout: [
                "Yoga & Flexibility",
                "Postpartum Fitness",
                "Nutrition Integration",
                "Strength & Conditioning",
                "Holistic Health",
              ],
              sameAs: [
                "https://www.linkedin.com/in/vaibhavi-likhite-2b4688221/",
              ],
            },
          },
        ],
      },
    ],
  },
  "doctors": {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Our Doctors - Holypills",
    description:
      "Meet the team of experienced Homeopathy doctors, Fitness coach, & Nutritionist at Holypills.",
    url: "https://holypills.in/doctor",
    numberOfItems: 3,
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        url: "https://holypills.in/doctors-details/dr-ila-kathuria",
      },
      {
        "@type": "ListItem",
        position: 2,
        url: "https://holypills.in/doctors-details/supriya-sharma",
      },
      {
        "@type": "ListItem",
        position: 3,
        url: "https://holypills.in/doctors-details/vaibhavi-likhite",
      },
      {
        "@type": "ListItem",
        position: 4,
        url: "https://holypills.in/doctors-details/chhavi-goel",
      },
    ],
    mainEntityOfPage: "https://holypills.in/doctor",
  },
  "doctors/": {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Our Doctors - Holypills",
    description:
      "Meet the team of experienced Homeopathy doctors, Fitness coach, & Nutritionist at Holypills.",
    url: "https://holypills.in/doctor",
    numberOfItems: 3,
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        url: "https://holypills.in/doctors-details/dr-ila-kathuria",
      },
      {
        "@type": "ListItem",
        position: 2,
        url: "https://holypills.in/doctors-details/supriya-sharma",
      },
      {
        "@type": "ListItem",
        position: 3,
        url: "https://holypills.in/doctors-details/vaibhavi-likhite",
      },
      {
        "@type": "ListItem",
        position: 4,
        url: "https://holypills.in/doctors-details/chhavi-goel",
      },
    ],
    mainEntityOfPage: "https://holypills.in/doctor",
  },
};
